import { useRef, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import LectureItem from "../../organisms/lecture/lectureItem";

function LectureSwiper({ dataList, isMiddle }) {
  const swiperRef = useRef();

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <Swiper
            onSwiper={(it) => {
              swiperRef.current = it;
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.snapIndex);
            }}
            slidesPerView={3}
            spaceBetween={30}
            grabCursor={true}
            slidesPerGroup={1}
            modules={[Pagination]}
          >
            {dataList?.length > 0
              ? dataList?.map((item) => {
                  return (
                    <SwiperSlide key={item.id}>
                      <LectureItem isMiddle={isMiddle} data={item} />
                    </SwiperSlide>
                  );
                })
              : null}
          </Swiper>
        </div>

        {activeIndex >= 1 ? (
          <img
            onClick={() => swiperRef.current?.slidePrev()}
            style={{
              position: "absolute",
              cursor: "pointer",
              left: 0,
              width: 48,
              height: 48,
              top: "44%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
              objectFit: "contain", // 원본 비율 유지
              borderRadius: 999,
            }}
            src="/assets/icons/left_swiper.png"
            alt="left_swiper"
          />
        ) : null}

        {activeIndex < Math.max(0, (dataList?.length ?? 0) - 3) && (
          <img
            onClick={() => swiperRef.current?.slideNext()}
            style={{
              position: "absolute",
              cursor: "pointer",
              right: -50,
              width: 48,
              height: 48,
              top: "44%",
              transform: "translate(-50%, -50%)",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
              objectFit: "contain", // 원본 비율 유지
              zIndex: 10,
              borderRadius: 999,
            }}
            src="/assets/icons/right_swiper.png"
            alt="right_swiper"
          />
        )}
      </div>
    </>
  );
}

export default LectureSwiper;
